import AppNavbar from "../components/Navbar/AppNavbar";
import Footer from "../components/Navbar/Footer";
import resetImg from '../assets/images/reset-password.png';
import { Form, Button } from "react-bootstrap";
import '../assets/css/resetPassword.scss';
import * as HeaderAuthentication from '../components/HeaderAuthentication';
import { useState } from "react";
import { postForgotPassword } from "./redux/action";
import { useDispatch } from "react-redux";
import failedImg from '../assets/images/failImg.png'
import successImg from '../assets/images/successImg.png'
import { useNavigate } from "react-router-dom";

const ForgetPassword = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [emailError, setEmailError] = useState("");

    const handleEmailSend = (e) => {
        e.preventDefault();

        if (!email.trim()) {
            setEmailError("Email is required");
            return;
        }

        const requestPayload = {
            email: email
        }
        const requestOption = {
            method: 'POST',
            mode: 'cors',
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(requestPayload),
        };

        dispatch(postForgotPassword(requestOption, setSuccessMessage, setErrorMessage));
        console.log('Reset Password Request:', requestPayload);
    }

    const handleSuccess = () => {
        navigate('/')
    }

    return (
        <div className="page-layout">
            <div className="page-content">
                <div className="reset-password-container d-flex">
                    <div className="reset-password-first-div">
                        <img src={resetImg} alt="Reset Password" />
                    </div>
                    <div className="reset-password-second-div">
                        <div className="reset-box">
                            {!successMessage && (
                                <>
                                    <h2><b>Forgot password</b></h2>
                                    <p className='pb-4 forgot-password-reset-text'>Enter your registered email address to receive a password reset link</p>
                                </>
                            )}
                            <Form onSubmit={handleEmailSend}>
                                {!successMessage && (
                                    <>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email</Form.Label>
                                            <div className="password-input-wrapper">
                                                <Form.Control
                                                    type="text"
                                                    value={email}
                                                    onChange={(e) => {
                                                        setEmail(e.target.value);
                                                        setEmailError("");
                                                        setErrorMessage("");
                                                    }}
                                                />
                                                {emailError && <div className="text-danger mt-1">{emailError}</div>}
                                            </div>
                                        </Form.Group>
                                        <Button className="reset-btn" type="submit">Send Email</Button>
                                    </>
                                )}

                                {/* Show error message if any */}
                                {errorMessage && (
                                    <div className="mt-3 d-flex flex-column justify-content-center align-items-center">
                                        {/* <h2><b>Failed !</b></h2> */}
                                        <p className="text-danger"> {errorMessage}</p>
                                        {/* <img src={failedImg} alt="failed" className="p-4 success-image" /> */}
                                    </div>
                                )}

                                {/* Show success message if any */}
                                {successMessage && (
                                    <div className="mt-3 d-flex flex-column justify-content-center align-items-center">
                                        <h2><b>Congratulations !</b></h2>
                                        <p className="text-success">{successMessage}</p>
                                        <img src={successImg} alt="success" className="p-4 success-image" />
                                        <Button className="reset-btn" onClick={handleSuccess}>Sign In</Button>
                                    </div>
                                )}
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            {/* <Footer /> */}
        </div>
    );
};

export default ForgetPassword;
